module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-600-latin12.c0aa69c.woff2";